/** Above this, the unread pill collapses to "99+". */
export const MAX_UNREAD_BADGE = 99

/** Normalises a possibly-missing unread count to a non-negative number. */
export function getUnreadCount(unreadCount?: number | null): number {
  return unreadCount ?? 0
}

/** Whether a conversation has any unread messages (drives bold + pill + mark-read). */
export function hasUnread(unreadCount?: number | null): boolean {
  return getUnreadCount(unreadCount) > 0
}

/** Label for the unread pill: the count, capped at "99+". */
export function formatUnreadBadge(unreadCount?: number | null): string {
  const count = getUnreadCount(unreadCount)
  return count > MAX_UNREAD_BADGE ? `${MAX_UNREAD_BADGE}+` : String(count)
}
